import { Grommet } from "grommet";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthenticatedBroadcasterOrModRoute from "./components/Authentication/AuthenticatedBroadcasterOrModRoute";
import AuthenticatedBroadcasterRoute from "./components/Authentication/AuthenticatedRouteBroadcaster";
import AuthenticatedUserRoute from "./components/Authentication/AuthenticatedUserRoute";
import ChipsLeaderboardWidget from "./components/ChipsLeaderBoard";
import DenyStatus from "./components/DenyStatus";
import LeaderBoard from "./components/LeaderBoard";
import DenyWarAnnoucement from "./components/OBSWidgets/DenyWarAnnoucement";
import BroadcasterSettings from "./components/pages/Broadcaster/Settings/BroadcasterSettings";
import TipMenuEditor from "./components/pages/Broadcaster/TipMenuEditor";
import BroadcasterDashboard from "./components/pages/broadcasters/BroadcasterDashboard";
import ChipsLeaderboard from "./components/pages/broadcasters/ChipsLeaderboard";
import VipMembers from "./components/pages/broadcasters/VipMembers";
import CustomTipMenuPage from "./components/pages/broadcasters/CustomTipMenuPage";
import TipQueue from "./components/pages/broadcasters/TipQueue";
import CommunityPage from "./components/pages/broadcasters/community/CommunityPage";
import TopTippersPage from "./components/pages/broadcasters/TopTippersPage";
import CarouselOne from "./components/pages/CarouselOne";
import { TipperCirclePage } from "./components/pages/CirclePacking";
import Dashboard from "./components/pages/dashboard/Dashboard";
import TipStatistics from "./components/pages/dashboard/TipStatistics";
import DenyStatusProgressBars from "./components/pages/DenyStatusProgressBar";
import DenyWarBar from "./components/pages/DenyWarBar";
import DenyWars from "./components/pages/DenyWars";
import ForgotPassword from "./components/pages/ForgotPassword";
import LoginPage from "./components/pages/LoginPage";
import Navigation from "./components/pages/Navigation";
import PaymentSuccessful from "./components/pages/PaymentSuccess";
import RecentTips from "./components/pages/RecentTips";
import RegisterPage from "./components/pages/Register";
import CustomTipHistory from "./components/pages/Tippers/CustomTipHistory";
import CustomTipMenu from "./components/pages/Tippers/CustomTipMenu";
import ShopDiscordTokens from "./components/pages/Tippers/discord/ShopDiscordTokens";
import Home from "./components/pages/Tippers/Home";
import LinkAccounts from "./components/pages/Tippers/LinkAccounts";
import MySubscriptions from "./components/pages/Tippers/MySubscriptions";
import TipperSettings from "./components/pages/Tippers/TipperSettings";
import TipperProfile from "./components/pages/Tippers/TipperProfile";
import SoundWidget from "./components/SoundWidget";
import TipperChipsWidget from "./components/TipperChipsWidget";
import { AuthProvider } from "./context/AuthProvider";
import { ProfilesProvider } from "./context/ProfilesProvider";
import { ThemeProvider } from "./context/ThemeProvider";
import { UserConfigProvider } from "./context/UserConfigProvider";
import defaultTheme from "./themes";

function App() {
  return (
    <ThemeProvider>
      <Grommet full theme={defaultTheme} className="bg-transparent">
        <BrowserRouter>
          <AuthProvider>
            <UserConfigProvider>
              <ProfilesProvider>
                <Routes>
                  {/* this is Authenticated routes*/}
                  <Route path="/" element={<Navigation />}>
                    <Route
                      path="login"
                      element={
                        <GoogleReCaptchaProvider
                          reCaptchaKey={
                            "6LfS1fsqAAAAAPmtn6T5q0tKRz94Suf2IqkED1hh"
                          }
                        >
                          <LoginPage />
                        </GoogleReCaptchaProvider>
                      }
                    />
                    <Route
                      path="register"
                      element={
                        <GoogleReCaptchaProvider
                          reCaptchaKey={
                            "6LfS1fsqAAAAAPmtn6T5q0tKRz94Suf2IqkED1hh"
                          }
                        >
                          <RegisterPage />
                        </GoogleReCaptchaProvider>
                      }
                    />
                    <Route
                      path="forgot-password"
                      element={
                        <GoogleReCaptchaProvider
                          reCaptchaKey={
                            "6LfS1fsqAAAAAPmtn6T5q0tKRz94Suf2IqkED1hh"
                          }
                        >
                          <ForgotPassword />
                        </GoogleReCaptchaProvider>
                      }
                    />

                    {/* Users that are broadcasters */}
                    <Route
                      element={
                        <AuthenticatedBroadcasterRoute broadcasterOnly />
                      }
                    >
                      <Route path="/" element={<Dashboard />} />
                      <Route path="community" element={<CommunityPage />} />
                      {/* Old links land on the matching tab. */}
                      <Route
                        path="tippers"
                        element={<CommunityPage defaultTab="tippers" />}
                      />
                      <Route
                        path="rein-users"
                        element={<CommunityPage defaultTab="users" />}
                      />
                      <Route
                        path="custom-tip-menu"
                        Component={CustomTipMenuPage}
                      />
                      <Route path="top-tippers" Component={TopTippersPage} />
                      <Route path="tip-statistics" Component={TipStatistics} />
                      <Route path="settings" Component={BroadcasterSettings} />

                      <Route
                        path="user-custom-tip-history"
                        element={<CustomTipHistory isBroadcaster />}
                      />

                      <Route path="deny-wars" Component={DenyWars} />
                    </Route>

                    {/* Broadcasters OR Mods */}
                    <Route element={<AuthenticatedBroadcasterOrModRoute />}>
                      <Route
                        path="broadcaster-dashboard"
                        Component={BroadcasterDashboard}
                      />
                      <Route
                        path="chips-leaderboard"
                        Component={ChipsLeaderboard}
                      />
                      <Route path="tip-menu-editor" Component={TipMenuEditor} />
                      <Route path="vip-members" Component={VipMembers} />
                      <Route path="tip-queue" Component={TipQueue} />
                      <Route
                        path="custom-tip-history"
                        element={<CustomTipHistory isBroadcaster={false} />}
                      />
                    </Route>

                    {/* users that are not broadcasters */}
                    <Route element={<AuthenticatedUserRoute />}>
                      <Route path="/Home" element={<Home />} />
                      <Route
                        path="/tipper-profile"
                        element={<TipperProfile />}
                      />
                      <Route path="/link-accounts" element={<LinkAccounts />} />
                      <Route path="/my-settings" element={<TipperSettings />} />
                      <Route
                        path="/shop-crimcoins"
                        element={<ShopDiscordTokens />}
                      />
                      {/*
                  <Route
                    path="/purchase-history"
                    element={<PurchaseHistory />}
                  /> */}
                      <Route
                        path="/payment-success"
                        element={<PaymentSuccessful />}
                      />
                      <Route path="/crimson-menu" element={<CustomTipMenu />} />
                      <Route
                        path="/my-subscriptions"
                        element={<MySubscriptions />}
                      />
                      <Route
                        path="chips-leaderboard"
                        Component={ChipsLeaderboard}
                      />
                      <Route
                        path="custom-tip-history"
                        element={<CustomTipHistory isBroadcaster={false} />}
                      />
                    </Route>
                  </Route>
                  <Route
                    path="chips-leaderboard-widget"
                    Component={ChipsLeaderboardWidget}
                  />
                  <Route
                    path="chips/:broadcaster/:username"
                    Component={TipperChipsWidget}
                  />
                  <Route path="sound-widget" Component={SoundWidget} />
                  <Route path="leaderboard" Component={LeaderBoard} />
                  <Route
                    path="denystatus"
                    element={<DenyStatus isWidget={true} />}
                  />
                  <Route
                    path="recent-tips"
                    Component={() => <RecentTips isTipNotesOnly={false} />}
                  />
                  <Route
                    path="recent-tips-notes"
                    Component={() => <RecentTips isTipNotesOnly={true} />}
                  />
                  <Route
                    path="denyprogress"
                    Component={DenyStatusProgressBars}
                  />
                  <Route
                    path="denywar"
                    element={<DenyWarBar shouldAutoHide />}
                  />
                  <Route path="carousel" Component={CarouselOne} />
                  <Route
                    path="deny-war-results"
                    Component={DenyWarAnnoucement}
                  />
                  {/* <Route path="battlepass" Component={BattlePass} /> */}
                  <Route path="deny-visual" Component={TipperCirclePage} />
                </Routes>
              </ProfilesProvider>
            </UserConfigProvider>
          </AuthProvider>
        </BrowserRouter>
        <ToastContainer theme="dark" />
      </Grommet>
    </ThemeProvider>
  );
}

export default App;
